export function m2ToHa(area: number): number {
  if (area) {
    return Math.round(area / 100) / 100;
  } else {
    return 0;
  }
}
